import { useAppSelector } from 'client/hooks/useAppSelector';

export const useDuration = () => {
  const { product, loading } = useAppSelector(({ productReducer }) => productReducer);

  const information = product?.information;

  return { information, loading };
};
